document.addEventListener('DOMContentLoaded', function() {

  // Hamburger button in headroom menu
  // Hamburger menu
  let menuToggleButton = document.querySelector('.menu-toggle-button');
  if (menuToggleButton) {

    const menuItems = document.querySelectorAll('.menu-headroom__mobile .nav.menu-main__mobile a');
    const hamburgerButton = document.querySelector('.hamburger-button');
    const body = document.body;

    const toggleMenu = () => {
      const isOpen = body.classList.toggle('menu-open');
      hamburgerButton.classList.toggle('is-active', isOpen);

      if (isOpen) {
        preventScroll()
        menuItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('animate-in');
          }, index * 50); // Staggering effect
        });
      } else {
        allowScroll();
        menuItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.remove('animate-in');
          }, index * 50); // Staggering effect in opposite direction
        });
      }
    };

    menuToggleButton.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMenu();
    });

    window.addEventListener('resize', () => {
      body.classList.remove('menu-open');
      hamburgerButton.classList.remove('is-active');
      allowScroll();
    });
  }

  // Animatie van elementen die binnen viewport komen
  // animateOnViewport(['slideme'], { type: 'slide-fade', distance: 50 });
  animateOnViewport(
    [
      'h1', 'h2', 'p'
    ], {
      type: 'fade',
      duration : 1
    });

  // Scroll to Hash of anchor
  document.querySelectorAll('.anchor').forEach(a => {
    a.addEventListener('click', e => {
      scrollToHash(a.getAttribute('href'), e);
    });
  });

  // Scroll to anchor on page load
  scrollToHash(window.location.hash);
});